import { render, staticRenderFns } from "./StartYourSelection.vue?vue&type=template&id=5805d33c&scoped=true"
import script from "./StartYourSelection.vue?vue&type=script&lang=js"
export * from "./StartYourSelection.vue?vue&type=script&lang=js"
import style0 from "./StartYourSelection.vue?vue&type=style&index=0&id=5805d33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805d33c",
  null
  
)

export default component.exports